import * as React from "react";
import { JobTypeTag, jobSerial } from "../jobType";
import { useState, useEffect } from "react";
import { Box, Typography, IconButton, TextField, InputAdornment } from "@mui/material";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { setlogo } from "./Nav/navSlice";
import { useNavigate } from "react-router-dom";
import { PENDING_REFRESH, useGetPendingJobCardsQuery } from "../api/apiSlice";
import { BG, CARD_BG, BORDER } from "../../Global/colors";

export default function PendingInstalls() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  dispatch(setlogo(false));

  // const { data, isSuccess } = useGetPendingJobCardsQuery(undefined, PENDING_REFRESH); // superseded by debounced search below
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(search), 400);
    return () => clearTimeout(timer);
  }, [search]);

  const { data, isSuccess } = useGetPendingJobCardsQuery(debouncedSearch, PENDING_REFRESH);

  if (!isSuccess) return null;

  const filtered = data.job_cards;

  return (
    <>
      <Helmet>
        <style>{`body { background: ${BG}; }`}</style>
      </Helmet>

      <Box sx={{ px: "20px", pt: "80px", pb: "40px", maxWidth: "480px", mx: "auto" }}>
        {/* Page heading */}
        <Box sx={{ mb: "20px" }}>
          <Typography sx={{ fontSize: "1.8rem", fontWeight: 800, color: "#fff", letterSpacing: "-0.025em", lineHeight: 1.15 }}>
            Pending installs
          </Typography>
          <Typography sx={{ fontSize: "0.85rem", color: "rgba(255,255,255,0.4)", mt: "5px" }}>
            Awaiting QE approval
          </Typography>
        </Box>

        <TextField
          fullWidth
          size="small"
          placeholder="Search by address, serial, IMSI…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            mb: "20px",
            "& .MuiOutlinedInput-root": {
              backgroundColor: CARD_BG,
              borderRadius: "10px",
              "& fieldset": { borderColor: BORDER },
              "&:hover fieldset": { borderColor: "rgba(255,255,255,0.25)" },
              "&.Mui-focused fieldset": { borderColor: "rgba(255,255,255,0.4)" },
            },
            "& .MuiInputBase-input": { color: "#fff", fontSize: "0.9rem" },
            "& .MuiInputBase-input::placeholder": { color: "rgba(255,255,255,0.35)", opacity: 1 },
            "& .MuiSvgIcon-root": { color: "rgba(255,255,255,0.35)" },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon sx={{ fontSize: "1.1rem" }} />
              </InputAdornment>
            ),
          }}
        />

        {filtered.length === 0 ? (
          <Typography sx={{ color: "rgba(255,255,255,0.4)", textAlign: "center", mt: "40px" }}>
            {search ? "No results" : "No pending installs"}
          </Typography>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {filtered.map((item) => (
              <Box
                key={item.id}
                onClick={() => navigate(`/QE/pending-installs/install/details/${item.id}`)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: CARD_BG,
                  border: `1px solid ${BORDER}`,
                  borderRadius: "12px",
                  px: "18px",
                  py: "16px",
                  cursor: "pointer",
                  transition: "background 0.15s",
                  "&:hover": { backgroundColor: "#1e2730" },
                }}
              >
                <Box sx={{ pr: "12px", minWidth: 0 }}>
                  <Typography sx={{ color: "#fff", fontSize: "0.95rem", fontWeight: 500 }}>
                    {item.address}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: "8px", mt: "4px" }}>
                    <JobTypeTag install_state={item.install_state} />
                    {jobSerial(item) && (
                      <Typography component="span" sx={{ color: "rgba(255,255,255,0.45)", fontSize: "0.75rem", fontFamily: "monospace" }}>
                        {jobSerial(item)}
                      </Typography>
                    )}
                  </Box>
                </Box>
                <IconButton size="small" sx={{ color: "rgba(255,255,255,0.3)", flexShrink: 0, p: "6px" }}>
                  <NotificationsNoneIcon sx={{ fontSize: "1.2rem" }} />
                </IconButton>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </>
  );
}
